/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WriteRouteImport } from './routes/write'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MemoriesRouteImport } from './routes/memories'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as HomeRouteImport } from './routes/home'
import { Route as EchoesRouteImport } from './routes/echoes'
import { Route as ComingSoonRouteImport } from './routes/coming-soon'
import { Route as CodexRouteImport } from './routes/codex'
import { Route as AwakeningRouteImport } from './routes/awakening'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as QuestQuestIdRouteImport } from './routes/quest.$questId'
import { Route as LetterLetterIdRouteImport } from './routes/letter.$letterId'
import { Route as AdminMemoryShardsRouteImport } from './routes/admin.memory-shards'
import { Route as AdminHealthRouteImport } from './routes/admin.health'
import { Route as AdminFallbacksRouteImport } from './routes/admin.fallbacks'
import { Route as AdminCostRouteImport } from './routes/admin.cost'
import { Route as AdminBondsRouteImport } from './routes/admin.bonds'
import { Route as AdminBeatsRouteImport } from './routes/admin.beats'
import { Route as AdminFallbacksIndexRouteImport } from './routes/admin.fallbacks.index'
import { Route as AdminBondsIndexRouteImport } from './routes/admin.bonds.index'
import { Route as AdminFallbacksIdRouteImport } from './routes/admin.fallbacks.$id'
import { Route as AdminBondsIdRouteImport } from './routes/admin.bonds.$id'

const WriteRoute = WriteRouteImport.update({
  id: '/write',
  path: '/write',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const MemoriesRoute = MemoriesRouteImport.update({
  id: '/memories',
  path: '/memories',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const EchoesRoute = EchoesRouteImport.update({
  id: '/echoes',
  path: '/echoes',
  getParentRoute: () => rootRouteImport,
} as any)
const ComingSoonRoute = ComingSoonRouteImport.update({
  id: '/coming-soon',
  path: '/coming-soon',
  getParentRoute: () => rootRouteImport,
} as any)
const CodexRoute = CodexRouteImport.update({
  id: '/codex',
  path: '/codex',
  getParentRoute: () => rootRouteImport,
} as any)
const AwakeningRoute = AwakeningRouteImport.update({
  id: '/awakening',
  path: '/awakening',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const QuestQuestIdRoute = QuestQuestIdRouteImport.update({
  id: '/quest/$questId',
  path: '/quest/$questId',
  getParentRoute: () => rootRouteImport,
} as any)
const LetterLetterIdRoute = LetterLetterIdRouteImport.update({
  id: '/letter/$letterId',
  path: '/letter/$letterId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMemoryShardsRoute = AdminMemoryShardsRouteImport.update({
  id: '/memory-shards',
  path: '/memory-shards',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHealthRoute = AdminHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFallbacksRoute = AdminFallbacksRouteImport.update({
  id: '/fallbacks',
  path: '/fallbacks',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCostRoute = AdminCostRouteImport.update({
  id: '/cost',
  path: '/cost',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBondsRoute = AdminBondsRouteImport.update({
  id: '/bonds',
  path: '/bonds',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBeatsRoute = AdminBeatsRouteImport.update({
  id: '/beats',
  path: '/beats',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFallbacksIndexRoute = AdminFallbacksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFallbacksRoute,
} as any)
const AdminBondsIndexRoute = AdminBondsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminBondsRoute,
} as any)
const AdminFallbacksIdRoute = AdminFallbacksIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminFallbacksRoute,
} as any)
const AdminBondsIdRoute = AdminBondsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminBondsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/admin': typeof AdminRouteWithChildren
  '/awakening': typeof AwakeningRoute
  '/codex': typeof CodexRoute
  '/coming-soon': typeof ComingSoonRoute
  '/echoes': typeof EchoesRoute
  '/home': typeof HomeRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/memories': typeof MemoriesRoute
  '/privacy': typeof PrivacyRoute
  '/verify': typeof VerifyRoute
  '/write': typeof WriteRoute
  '/admin/beats': typeof AdminBeatsRoute
  '/admin/bonds': typeof AdminBondsRouteWithChildren
  '/admin/cost': typeof AdminCostRoute
  '/admin/fallbacks': typeof AdminFallbacksRouteWithChildren
  '/admin/health': typeof AdminHealthRoute
  '/admin/memory-shards': typeof AdminMemoryShardsRoute
  '/letter/$letterId': typeof LetterLetterIdRoute
  '/quest/$questId': typeof QuestQuestIdRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/bonds/$id': typeof AdminBondsIdRoute
  '/admin/fallbacks/$id': typeof AdminFallbacksIdRoute
  '/admin/bonds/': typeof AdminBondsIndexRoute
  '/admin/fallbacks/': typeof AdminFallbacksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/awakening': typeof AwakeningRoute
  '/codex': typeof CodexRoute
  '/coming-soon': typeof ComingSoonRoute
  '/echoes': typeof EchoesRoute
  '/home': typeof HomeRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/memories': typeof MemoriesRoute
  '/privacy': typeof PrivacyRoute
  '/verify': typeof VerifyRoute
  '/write': typeof WriteRoute
  '/admin/beats': typeof AdminBeatsRoute
  '/admin/cost': typeof AdminCostRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/memory-shards': typeof AdminMemoryShardsRoute
  '/letter/$letterId': typeof LetterLetterIdRoute
  '/quest/$questId': typeof QuestQuestIdRoute
  '/admin': typeof AdminIndexRoute
  '/admin/bonds/$id': typeof AdminBondsIdRoute
  '/admin/fallbacks/$id': typeof AdminFallbacksIdRoute
  '/admin/bonds': typeof AdminBondsIndexRoute
  '/admin/fallbacks': typeof AdminFallbacksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/admin': typeof AdminRouteWithChildren
  '/awakening': typeof AwakeningRoute
  '/codex': typeof CodexRoute
  '/coming-soon': typeof ComingSoonRoute
  '/echoes': typeof EchoesRoute
  '/home': typeof HomeRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/memories': typeof MemoriesRoute
  '/privacy': typeof PrivacyRoute
  '/verify': typeof VerifyRoute
  '/write': typeof WriteRoute
  '/admin/beats': typeof AdminBeatsRoute
  '/admin/bonds': typeof AdminBondsRouteWithChildren
  '/admin/cost': typeof AdminCostRoute
  '/admin/fallbacks': typeof AdminFallbacksRouteWithChildren
  '/admin/health': typeof AdminHealthRoute
  '/admin/memory-shards': typeof AdminMemoryShardsRoute
  '/letter/$letterId': typeof LetterLetterIdRoute
  '/quest/$questId': typeof QuestQuestIdRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/bonds/$id': typeof AdminBondsIdRoute
  '/admin/fallbacks/$id': typeof AdminFallbacksIdRoute
  '/admin/bonds/': typeof AdminBondsIndexRoute
  '/admin/fallbacks/': typeof AdminFallbacksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/admin'
    | '/awakening'
    | '/codex'
    | '/coming-soon'
    | '/echoes'
    | '/home'
    | '/inbox'
    | '/login'
    | '/memories'
    | '/privacy'
    | '/verify'
    | '/write'
    | '/admin/beats'
    | '/admin/bonds'
    | '/admin/cost'
    | '/admin/fallbacks'
    | '/admin/health'
    | '/admin/memory-shards'
    | '/letter/$letterId'
    | '/quest/$questId'
    | '/admin/'
    | '/admin/bonds/$id'
    | '/admin/fallbacks/$id'
    | '/admin/bonds/'
    | '/admin/fallbacks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/awakening'
    | '/codex'
    | '/coming-soon'
    | '/echoes'
    | '/home'
    | '/inbox'
    | '/login'
    | '/memories'
    | '/privacy'
    | '/verify'
    | '/write'
    | '/admin/beats'
    | '/admin/cost'
    | '/admin/health'
    | '/admin/memory-shards'
    | '/letter/$letterId'
    | '/quest/$questId'
    | '/admin'
    | '/admin/bonds/$id'
    | '/admin/fallbacks/$id'
    | '/admin/bonds'
    | '/admin/fallbacks'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/admin'
    | '/awakening'
    | '/codex'
    | '/coming-soon'
    | '/echoes'
    | '/home'
    | '/inbox'
    | '/login'
    | '/memories'
    | '/privacy'
    | '/verify'
    | '/write'
    | '/admin/beats'
    | '/admin/bonds'
    | '/admin/cost'
    | '/admin/fallbacks'
    | '/admin/health'
    | '/admin/memory-shards'
    | '/letter/$letterId'
    | '/quest/$questId'
    | '/admin/'
    | '/admin/bonds/$id'
    | '/admin/fallbacks/$id'
    | '/admin/bonds/'
    | '/admin/fallbacks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  AdminRoute: typeof AdminRouteWithChildren
  AwakeningRoute: typeof AwakeningRoute
  CodexRoute: typeof CodexRoute
  ComingSoonRoute: typeof ComingSoonRoute
  EchoesRoute: typeof EchoesRoute
  HomeRoute: typeof HomeRoute
  InboxRoute: typeof InboxRoute
  LoginRoute: typeof LoginRoute
  MemoriesRoute: typeof MemoriesRoute
  PrivacyRoute: typeof PrivacyRoute
  VerifyRoute: typeof VerifyRoute
  WriteRoute: typeof WriteRoute
  LetterLetterIdRoute: typeof LetterLetterIdRoute
  QuestQuestIdRoute: typeof QuestQuestIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/write': {
      id: '/write'
      path: '/write'
      fullPath: '/write'
      preLoaderRoute: typeof WriteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memories': {
      id: '/memories'
      path: '/memories'
      fullPath: '/memories'
      preLoaderRoute: typeof MemoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/echoes': {
      id: '/echoes'
      path: '/echoes'
      fullPath: '/echoes'
      preLoaderRoute: typeof EchoesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coming-soon': {
      id: '/coming-soon'
      path: '/coming-soon'
      fullPath: '/coming-soon'
      preLoaderRoute: typeof ComingSoonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/codex': {
      id: '/codex'
      path: '/codex'
      fullPath: '/codex'
      preLoaderRoute: typeof CodexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/awakening': {
      id: '/awakening'
      path: '/awakening'
      fullPath: '/awakening'
      preLoaderRoute: typeof AwakeningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/quest/$questId': {
      id: '/quest/$questId'
      path: '/quest/$questId'
      fullPath: '/quest/$questId'
      preLoaderRoute: typeof QuestQuestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/letter/$letterId': {
      id: '/letter/$letterId'
      path: '/letter/$letterId'
      fullPath: '/letter/$letterId'
      preLoaderRoute: typeof LetterLetterIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/memory-shards': {
      id: '/admin/memory-shards'
      path: '/memory-shards'
      fullPath: '/admin/memory-shards'
      preLoaderRoute: typeof AdminMemoryShardsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/health': {
      id: '/admin/health'
      path: '/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AdminHealthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/fallbacks': {
      id: '/admin/fallbacks'
      path: '/fallbacks'
      fullPath: '/admin/fallbacks'
      preLoaderRoute: typeof AdminFallbacksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/cost': {
      id: '/admin/cost'
      path: '/cost'
      fullPath: '/admin/cost'
      preLoaderRoute: typeof AdminCostRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/bonds': {
      id: '/admin/bonds'
      path: '/bonds'
      fullPath: '/admin/bonds'
      preLoaderRoute: typeof AdminBondsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/beats': {
      id: '/admin/beats'
      path: '/beats'
      fullPath: '/admin/beats'
      preLoaderRoute: typeof AdminBeatsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/fallbacks/': {
      id: '/admin/fallbacks/'
      path: '/'
      fullPath: '/admin/fallbacks/'
      preLoaderRoute: typeof AdminFallbacksIndexRouteImport
      parentRoute: typeof AdminFallbacksRoute
    }
    '/admin/bonds/': {
      id: '/admin/bonds/'
      path: '/'
      fullPath: '/admin/bonds/'
      preLoaderRoute: typeof AdminBondsIndexRouteImport
      parentRoute: typeof AdminBondsRoute
    }
    '/admin/fallbacks/$id': {
      id: '/admin/fallbacks/$id'
      path: '/$id'
      fullPath: '/admin/fallbacks/$id'
      preLoaderRoute: typeof AdminFallbacksIdRouteImport
      parentRoute: typeof AdminFallbacksRoute
    }
    '/admin/bonds/$id': {
      id: '/admin/bonds/$id'
      path: '/$id'
      fullPath: '/admin/bonds/$id'
      preLoaderRoute: typeof AdminBondsIdRouteImport
      parentRoute: typeof AdminBondsRoute
    }
  }
}

interface AdminBondsRouteChildren {
  AdminBondsIdRoute: typeof AdminBondsIdRoute
  AdminBondsIndexRoute: typeof AdminBondsIndexRoute
}

const AdminBondsRouteChildren: AdminBondsRouteChildren = {
  AdminBondsIdRoute: AdminBondsIdRoute,
  AdminBondsIndexRoute: AdminBondsIndexRoute,
}

const AdminBondsRouteWithChildren = AdminBondsRoute._addFileChildren(
  AdminBondsRouteChildren,
)

interface AdminFallbacksRouteChildren {
  AdminFallbacksIdRoute: typeof AdminFallbacksIdRoute
  AdminFallbacksIndexRoute: typeof AdminFallbacksIndexRoute
}

const AdminFallbacksRouteChildren: AdminFallbacksRouteChildren = {
  AdminFallbacksIdRoute: AdminFallbacksIdRoute,
  AdminFallbacksIndexRoute: AdminFallbacksIndexRoute,
}

const AdminFallbacksRouteWithChildren = AdminFallbacksRoute._addFileChildren(
  AdminFallbacksRouteChildren,
)

interface AdminRouteChildren {
  AdminBeatsRoute: typeof AdminBeatsRoute
  AdminBondsRoute: typeof AdminBondsRouteWithChildren
  AdminCostRoute: typeof AdminCostRoute
  AdminFallbacksRoute: typeof AdminFallbacksRouteWithChildren
  AdminHealthRoute: typeof AdminHealthRoute
  AdminMemoryShardsRoute: typeof AdminMemoryShardsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminBeatsRoute: AdminBeatsRoute,
  AdminBondsRoute: AdminBondsRouteWithChildren,
  AdminCostRoute: AdminCostRoute,
  AdminFallbacksRoute: AdminFallbacksRouteWithChildren,
  AdminHealthRoute: AdminHealthRoute,
  AdminMemoryShardsRoute: AdminMemoryShardsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  AdminRoute: AdminRouteWithChildren,
  AwakeningRoute: AwakeningRoute,
  CodexRoute: CodexRoute,
  ComingSoonRoute: ComingSoonRoute,
  EchoesRoute: EchoesRoute,
  HomeRoute: HomeRoute,
  InboxRoute: InboxRoute,
  LoginRoute: LoginRoute,
  MemoriesRoute: MemoriesRoute,
  PrivacyRoute: PrivacyRoute,
  VerifyRoute: VerifyRoute,
  WriteRoute: WriteRoute,
  LetterLetterIdRoute: LetterLetterIdRoute,
  QuestQuestIdRoute: QuestQuestIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
